/**
 * A reason for every token.
 *
 * This panel is the product as much as the code is. Nobody can preview a dive
 * preset until they surface, so the only thing that makes a generated code
 * trustworthy is being able to read why each part of it is there.
 */

import type { Token } from "../lib/tokens";

export function WhyList({ tokens, omitted }: { tokens: readonly Token[]; omitted: readonly Token[] }) {
  return (
    <ul className="m-0 mt-4 list-none p-0">
      {tokens.map((token, i) => (
        <li
          key={`${token.text}-${i}`}
          className="grid grid-cols-[108px_1fr] gap-3 border-t border-slate-line py-[7px]"
        >
          <code className="break-all font-mono text-[12.5px] font-semibold text-deep">
            {token.text}
          </code>
          <p className="m-0 text-[13px]">
            <strong className="font-semibold">{token.label}.</strong> {token.rationale}
          </p>
        </li>
      ))}

      {omitted.map((token, i) => (
        <li
          key={`omitted-${token.text}-${i}`}
          className="grid grid-cols-[108px_1fr] gap-3 border-t border-slate-line py-[7px] opacity-55"
        >
          <code className="break-all font-mono text-[12.5px] font-semibold text-graphite-2 line-through">
            {token.text}
          </code>
          <p className="m-0 text-[13px]">
            <strong className="font-semibold">{token.label}.</strong> Left out — this camera cannot
            act on it, and an ignored token is character budget spent on nothing.
          </p>
        </li>
      ))}
    </ul>
  );
}
